/**
 * Created by Jerker Nord on 2018-05-21.
 */

import {BaseController} from "@nolimitcity/slot-game/bin/core/base/BaseController";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SpinEvent} from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import {GameMode, IGameModeChangedData} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {isNumber} from "util";
import {IceIceYetiWildPresentationEvent} from "../event/IceIceYetiWildPresentationEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {IIceIceYetiParsedServerData} from "../server/data/IIceIceYetiParsedServerData";
import {IceIceYetiReelIceView} from "./IceIceYetiReelIceView";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {ScreenEvent} from "@nolimitcity/slot-game/bin/core/screen/event/ScreenEvent";

export class IceIceYetiReelIceController extends BaseController {

    public static readonly PLAY_ALL_ICE_SHAKE:string = "iceIceYetiReelIceController_playAllIceShake";
    public static readonly STOP_ALL_ICE_SHAKE:string = "iceIceYetiReelIceController_stopAllIceShake";
    public static readonly PLAY_ICE_ATTENTION:string = "iceIceYetiReelIceController_playIceAttention";
    public static readonly RESET_ALL_ICE_ATTENTION:string = "iceIceYetiReelIceController_resetAllIceAttention";

    private _view:IceIceYetiReelIceView;
    private _data:ParsedServerData;
    private _activeGameAreaBeforeSpin:boolean[][];
    private _currentMode:string;

    get view():IceIceYetiReelIceView {
        return this._view;
    }

    constructor() {
        super();
        this._view = new IceIceYetiReelIceView();
        this.addEventListeners();
    }

    protected addEventListeners():void {
        EventHandler.addEventListener(this, GameModeEvent.CHANGE_MODE, (event:GameEvent) => this.onChangeGameMode(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onServerDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ScreenEvent.GAME_RESTORE, (event:GameEvent) => this.onRestore());
        EventHandler.addEventListener(this, SpinEvent.BEFORE_START, (event:GameEvent) => this.onBeforeSpinStart());
        EventHandler.addEventListener(this, IceIceYetiWildPresentationEvent.CRACK_ICE, (event:GameEvent):void => this.playIceCracks(event.params[0]));
        EventHandler.addEventListener(this, IceIceYetiReelIceController.PLAY_ALL_ICE_SHAKE, (event:GameEvent):void => this.playAllIceShake());
        EventHandler.addEventListener(this, IceIceYetiReelIceController.STOP_ALL_ICE_SHAKE, (event:GameEvent):void => this.stopAllIceShake());
        EventHandler.addEventListener(this, IceIceYetiReelIceController.PLAY_ICE_ATTENTION, (event:GameEvent):void => this.playIceAttention(event.params[0], event.params[1], event.params[2]));
        EventHandler.addEventListener(this, IceIceYetiReelIceController.RESET_ALL_ICE_ATTENTION, (event:GameEvent):void => this.resetAllIceAttention());
    }

    private onChangeGameMode(data:IGameModeChangedData):void {
        if(data.newMode === this._currentMode) {
            return;
        }
        this._currentMode = data.newMode;
        this._view.changeMode(data.newMode);
    }

    private onRestore():void {
        this._view.restoreIce(this._activeGameAreaBeforeSpin);
    }

    private onServerDataParsed(data:IIceIceYetiParsedServerData) {
        this._data = data;
        this._activeGameAreaBeforeSpin = data.activeGameAreaBeforeSpin;
    }

    private onBeforeSpinStart():void {
        if(this._data.nextMode === GameMode.NORMAL) {
            this._view.resetAllIce();
        }
    }

    private playIceCracks(areaOpenPositions:PIXI.Point[]):void {
        this._view.playIceCracks(areaOpenPositions);
    }

    private playAllIceShake():void {
        this._view.playAllIceShake();
    }

    private stopAllIceShake():void {
        this._view.stopAllIceShake();
    }

    private playIceAttention(reelId:number, symbolId:number, playSound:boolean):void {
        this._view.playIceAttention(reelId, symbolId, playSound);
    }

    private resetAllIceAttention():void {
        this._view.resetAllIceAttention();
    }
}